import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ToasterService } from 'angular2-toaster';
import { ApplicationStateService } from '../../services/application-state.service';
import { OptionsAdminService } from '../../services/options-admin.service';
import { ModelService } from '../../services/model.service';
import { LoadingSpinnerService } from "../../services/loading-spinner.service";
import { QuoteInfoService } from "../../services/quote-info.service";
import { BrowserWidthService } from "../../services/browser-width.service";
import { OptionsService } from "../../services/options.service";

@Component({
    selector: 'toastr-html',
    template: `
    Selecting a new Model will remove all previous selections. 
    Continue with selection?
    <p><button class="yeti-button-primary-inverse"
    (click)="chooseYes()">Yes</button><button class="yeti-button-primary-inverse"
    (click)="chooseNo()">No</button></p>
    `,
    styles: ['.yeti-button-primary-inverse { width: 45%; }']
})
export class ToastrModelsComponent implements OnInit {

    constructor(
        private applicationStateService: ApplicationStateService,
        private toasterService: ToasterService,
        private router: Router,
        private optionsAdminService: OptionsAdminService,
        private modelService: ModelService,
        private spinner: LoadingSpinnerService,
        private quoteInfoService: QuoteInfoService,
        public browserWidthService: BrowserWidthService,
        private optionsService: OptionsService
    ) {
    }

    ngOnInit() {
        this.browserWidthService.disableBackground$.next(true);
        setTimeout(() => {
            this.browserWidthService.modalActive$.next(true);
        }, 1);
    }

    chooseYes() {
        this.browserWidthService.disableBackground$.next(false);
        this.browserWidthService.modalActive$.next(false);
        this.optionsService.initialOptionPageLoad$.next(true);
        this.quoteInfoService.creatingBaseOptions$.next(true);
        if (this.applicationStateService.chosenModel) {
            this.applicationStateService.setModel(this.applicationStateService.chosenModel, true)
                .subscribe(response => {
                    this.applicationStateService.chosenModel = undefined;
                    this.toasterService.clear();
                    this.spinner.showSpinner();
                    this.applicationStateService.setQuote(response);
                    let quote = this.applicationStateService.getQuote();

                    this.optionsAdminService.getOptionsAdminCategories(quote.plantId, quote.modelId).subscribe(categories => {
                        if (categories.length > 0) {
                            this.applicationStateService.setCategoryId(categories[0].WebCategoryId);
                        }
                        this.modelService.setBaseOptionsForModel(quote.quoteId, Number(quote.retailerNumber))
                            .subscribe(baseOptions => {
                                this.quoteInfoService.creatingBaseOptions$.next(false);
                                this.quoteInfoService.optionsTotal$.next(0.00);
                                this.router.navigate(['options-configuration', quote.quoteId]);
                            });
                    });
                });
        }
    }

    chooseNo() {
        this.browserWidthService.disableBackground$.next(false);
        this.browserWidthService.modalActive$.next(false);
        this.applicationStateService.chosenModel = undefined;
        this.toasterService.clear();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/toastr-models/toastr-html.component.ts